function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\u77E9\u5F62");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u7BA1\\u7406-\\u60AC\\u505C\\u5C55\\u793A",
  transform: "translate(-32.000000, -555.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u6807\\u7B7E\\u7BA1\\u7406",
  transform: "translate(32.000000, 555.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(3.000000, 3.000000)",
  fill: "#666666"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.19376105,0.000776287361 C10.7540151,0.00625250493 12.7006744,0.0774433333 12.7208667,0.0774433333 C13.3695333,0.0774433333 13.9155333,0.623443333 13.9155333,1.29311 C14.1208667,6.76711 13.9178667,6.96777667 13.7032,7.18011 L13.7032,7.18011 L7.2422,13.6434433 C7.01586667,13.8697767 6.7102,13.99811 6.38353333,13.99811 C6.0592,13.99811 5.7512,13.8697767 5.5202,13.64111 L5.5202,13.64111 L0.358866667,8.47511 C-0.117133333,7.99911 -0.119466667,7.22444333 0.3542,6.75077667 L0.3542,6.75077667 L6.81753333,0.28511 C7.01353333,0.08911 7.1792,0.000443333333 9.00853333,0.000443333333 Z M9.0062,1.21844333 C8.10086667,1.21844333 7.7182,1.24411 7.56186667,1.26044333 L7.56186667,1.26044333 L1.21753333,7.60944333 L6.38353333,12.78011 L6.3882,12.78011 L12.7325333,6.43111 C12.8072,5.82677667 12.7768667,3.43511 12.6952,1.31644333 C12.6555333,1.29544333 10.5718667,1.21844333 9.0062,1.21844333 Z M9.16183333,2.32047667 C10.3215,2.32047667 11.2618333,3.26314333 11.2618333,4.42281 C11.2618333,5.58014333 10.3215,6.52514333 9.16183333,6.52514333 C8.0045,6.52514333 7.06183333,5.58014333 7.06183333,4.42281 C7.06183333,3.26314333 8.0045,2.32047667 9.16183333,2.32047667 Z M9.16183333,3.51047667 C8.65783333,3.51047667 8.24716667,3.91881 8.24716667,4.42281 C8.24716667,4.92681 8.65783333,5.33747667 9.16183333,5.33747667 C9.66583333,5.33747667 10.0741667,4.92681 10.0765,4.42281 C10.0765,3.91881 9.66583333,3.51047667 9.16183333,3.51047667 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408"
})))));

var SvgTagManage = function SvgTagManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTagManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag_manage.f2addde0.svg";
export { ForwardRef as ReactComponent };